import Cashout from './Cashout'

export default Cashout
